import type { FormatDateOptions, IntlShape } from 'react-intl';

const formatDate = (
  intl: IntlShape,
  date: string,
  formatOptions?: FormatDateOptions
): string =>
  intl.formatDate(
    date,
    formatOptions || {
      year: 'numeric',
      month: '2-digit',
    }
  );

export const formatRangeDate = (
  intl: IntlShape,
  startDate: string,
  endDate?: string | null,
  formatOptions?: FormatDateOptions
): string =>
  [
    formatDate(intl, startDate, formatOptions),
    endDate
      ? formatDate(intl, endDate, formatOptions)
      : intl.formatMessage({ id: 'CRATE_VITA_PREVIEW_PRESENT' }),
  ].join(' - ');
